export const selectNotificationsMap = state => state.notifications.items;
